import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import AdLayout from './components/AdLayout';
import PrivacyBanner from './components/PrivacyBanner';

// Import pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import EmojiKeyboard from './pages/EmojiKeyboard';
import Search from './pages/Search';
import Disclaimer from './pages/Disclaimer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Sitemap from './pages/Sitemap';

// Import tools
import TextToEmoji from './pages/TextToEmoji';
import TextToEmojiPicture from './pages/TextToEmojiPicture';
import TextReplicator from './pages/TextReplicator';

// Import emoji pages
import Hearts5 from './pages/Hearts5';
import Hearts50 from './pages/Hearts50';
import Hearts100 from './pages/Hearts100';
import HeartEmoji1000 from './pages/HeartEmoji1000';
import Kiss1000 from './pages/Kiss1000';
import Kiss500 from './pages/Kiss500';
import Kiss100 from './pages/Kiss100';
import Kiss50 from './pages/Kiss50';
import Kiss10 from './pages/Kiss10';
import Kiss5 from './pages/Kiss5';
import Sad1000 from './pages/Sad1000';
import Sad500 from './pages/Sad500';
import Sad100 from './pages/Sad100';
import Sad50 from './pages/Sad50';
import Sad10 from './pages/Sad10';
import Sad5 from './pages/Sad5';
import Moon1000 from './pages/Moon1000';
import Butterfly1000 from './pages/Butterfly1000';
import Roses100 from './pages/Roses100';
import TwoEmoji from './pages/TwoEmoji';
import HugEmoji from './pages/HugEmoji';
import CryingEmoji from './pages/CryingEmoji';
import IphoneEmoji from './pages/IphoneEmoji';
import PopCulture from './pages/PopCulture';
import FlagsSymbols from './pages/FlagsSymbols';
import LoveEmojis from './pages/LoveEmojis';
import FoodEmojis from './pages/FoodEmojis';
import HeartEmoji from './pages/HeartEmoji';
import RedHearts1000 from './pages/RedHearts1000';
import RoseCopyPaste from './pages/RoseCopyPaste';
import CopyPasteEmoji from './pages/CopyPasteEmoji';
import CountDuplicates from './pages/CountDuplicates';
import Christmas1000 from './pages/Christmas1000';
import FoodDrink from './pages/FoodDrink';
import BlueRoses1000 from './pages/BlueRoses1000';
import RoseEmoji from './pages/RoseEmoji';
import Roses1000 from './pages/Roses1000';
import Party1000 from './pages/Party1000';
import Laugh1000 from './pages/Laugh1000';
import Sorry1000 from './pages/Sorry1000';
import Santa100 from './pages/Santa100';
import HappyChristmas50 from './pages/HappyChristmas50';
import ILoveYou10000 from './pages/ILoveYou10000';
import LoveLetter1000 from './pages/LoveLetter1000';
import Happy1000 from './pages/Happy1000';
import NewEmoji from './pages/NewEmoji';
import ZeroEmoji from './pages/ZeroEmoji';
import Clap1000 from './pages/Clap1000';
import Fire1000 from './pages/Fire1000';
import Star1000 from './pages/Star1000';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-purple-50">
          <Header />
          <PrivacyBanner />
          <main className="flex-grow">
            <AdLayout>
              <Routes>
                {/* Main Pages */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/emoji-keyboard" element={<EmojiKeyboard />} />
                <Route path="/search" element={<Search />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/sitemap" element={<Sitemap />} />

                {/* Tools */}
                <Route path="/text-to-emoji" element={<TextToEmoji />} />
                <Route path="/text-to-emoji-picture" element={<TextToEmojiPicture />} />
                <Route path="/text-replicator" element={<TextReplicator />} />

                {/* Heart Collections */}
                <Route path="/hearts-5" element={<Hearts5 />} />
                <Route path="/hearts-50" element={<Hearts50 />} />
                <Route path="/hearts-100" element={<Hearts100 />} />
                <Route path="/hearts-1000" element={<HeartEmoji1000 />} />

                {/* Kiss Collections */}
                <Route path="/kiss-1000" element={<Kiss1000 />} />
               <Route path="/kiss-500" element={<Kiss500 />} />
               <Route path="/kiss-100" element={<Kiss100 />} />
               <Route path="/kiss-50" element={<Kiss50 />} />
               <Route path="/kiss-10" element={<Kiss10 />} />
               <Route path="/kiss-5" element={<Kiss5 />} />

                {/* Other Collections */}
                <Route path="/christmas-1000" element={<Christmas1000 />} />
                <Route path="/food-drink" element={<FoodDrink />} />
                <Route path="/party-1000" element={<Party1000 />} />
                <Route path="/laugh-1000" element={<Laugh1000 />} />
                <Route path="/sad-1000" element={<Sad1000 />} />
                <Route path="/sorry-1000" element={<Sorry1000 />} />
                <Route path="/santa-100" element={<Santa100 />} />
                <Route path="/happy-christmas-50" element={<HappyChristmas50 />} />
                <Route path="/i-love-you-10000" element={<ILoveYou10000 />} />
                <Route path="/love-letter-1000" element={<LoveLetter1000 />} />
                <Route path="/happy-1000" element={<Happy1000 />} />
                <Route path="/new-emojis" element={<NewEmoji />} />

               {/* Sad Collections */}
               <Route path="/sad-500" element={<Sad500 />} />
               <Route path="/sad-100" element={<Sad100 />} />
               <Route path="/sad-50" element={<Sad50 />} />
               <Route path="/sad-10" element={<Sad10 />} />
               <Route path="/sad-5" element={<Sad5 />} />

               {/* Additional Collections */}
               <Route path="/moon-1000" element={<Moon1000 />} />
               <Route path="/happy-1000" element={<Happy1000 />} />
               <Route path="/butterfly-1000" element={<Butterfly1000 />} />
               <Route path="/roses-100" element={<Roses100 />} />
               <Route path="/two" element={<TwoEmoji />} />
               <Route path="/hug" element={<HugEmoji />} />
               <Route path="/crying" element={<CryingEmoji />} />
               <Route path="/iphone-emojis" element={<IphoneEmoji />} />
               <Route path="/pop-culture" element={<PopCulture />} />
               <Route path="/flags-symbols" element={<FlagsSymbols />} />
               <Route path="/love-emojis" element={<LoveEmojis />} />
               <Route path="/food-emojis" element={<FoodEmojis />} />
               <Route path="/heart" element={<HeartEmoji />} />
               <Route path="/heart-emoji-1000" element={<HeartEmoji1000 />} />
               <Route path="/red-heart-emoji-1000" element={<RedHearts1000 />} />
               <Route path="/rose-copy-paste" element={<RoseCopyPaste />} />
               <Route path="/copy-paste-emoji" element={<CopyPasteEmoji />} />
               <Route path="/count-duplicates" element={<CountDuplicates />} />
                <Route path="/zero" element={<ZeroEmoji />} />
                <Route path="/clap-1000" element={<Clap1000 />} />
                <Route path="/fire-1000" element={<Fire1000 />} />
                <Route path="/star-1000" element={<Star1000 />} />
                <Route path="/blue-roses-1000" element={<BlueRoses1000 />} />
                <Route path="/rose" element={<RoseEmoji />} />
                <Route path="/roses-1000" element={<Roses1000 />} />
              </Routes>
            </AdLayout>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;